import { CognitoUserPool } from 'amazon-cognito-identity-js';

const userPoolKey = "us-east-1_4sEivrOzP";
const clientIdKey = "d93s79p6694t82viivf66am2p";

const poolData = new CognitoUserPool({
  UserPoolId: userPoolKey,
  ClientId: clientIdKey
});

export default poolData;